<template>
  <div class="keywords-rank" style="margin-bottom: 50px;">
    <el-table :data="productSearchKeywordDataDTOList" border style="width: 100%" cell-class-name="table-cell-no-padding"
              row-class-name="table-row-no-padding" header-cell-class-name="table-header-cell-no-padding">
      <el-table-column label="序号" width="35px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="keyword" label="keyword" width="100px">
        <template v-slot="scope">
          <el-button type="text" style="margin-left: 6px;" @click="openHistoryDialog(scope.row)" aria-multiline="true">
            {{ scope.row.keyword }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="rankOfKeyword" label="keyword排名" width="60px" align="center" sortable>
      </el-table-column>
      <el-table-column width="160px" align="center">
        <template slot="header" slot-scope="scope">
          <div>本品</div>
          <el-image :src="competitionProductDataDTO.imgUrl" style="height: 40px; width: 40px" fit="fill">
          </el-image>
          <div>{{ competitionProductDataDTO.asin }}</div>
          <div>商店名称:{{ competitionProductDataDTO.shopName }}</div>
          <div>单价:{{ competitionProductDataDTO.price }}</div>
          <div class="sub-heder">
            <span class="ads-rank">广告排名</span>
            <span class="search-key-rank">搜索引擎排名</span>
          </div>
        </template>
        <template v-slot="scope">
          <div class="rank-box">
            <div class="ads-rank">{{ scope.row.advertiseRankOfMolova }}</div>
            <div class="search-key-rank">{{ scope.row.rankOfMolova }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct1!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品1</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct1" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{ competitionProductDataDTO.asinOfCompetitionProduct1 }}</div>
          <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct1 }}</div>
          <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct1 }}</div>
          <div class="sub-heder">
            <span class="ads-rank">广告排名</span>
            <span class="search-key-rank">搜索引擎排名</span>
          </div>
        </template>
        <template v-slot="scope">
          <div class="rank-box">
            <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct1 }}</span>
            <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct1 }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct2!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品2</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct2" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{ competitionProductDataDTO.asinOfCompetitionProduct2 }}</div>
          <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct2 }}</div>
          <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct2 }}</div>
          <div class="sub-heder">
            <span class="ads-rank">广告排名</span>
            <span class="search-key-rank">搜索引擎排名</span>
          </div>
        </template>
        <template v-slot="scope">
          <div class="rank-box">
            <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct2 }}</span>
            <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct2 }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct3!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品3</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct3" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{ competitionProductDataDTO.asinOfCompetitionProduct3 }}</div>
          <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct3 }}</div>
          <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct3 }}</div>
          <div class="sub-heder">
            <span class="ads-rank">广告排名</span>
            <span class="search-key-rank">搜索引擎排名</span>
          </div>
        </template>
        <template v-slot="scope">
          <div class="rank-box">
            <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct3 }}</span>
            <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct3 }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct4!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品4</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct4" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{ competitionProductDataDTO.asinOfCompetitionProduct4 }}</div>
          <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct4 }}</div>
          <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct4 }}</div>
          <div class="sub-heder">
            <span class="ads-rank">广告排名</span>
            <span class="search-key-rank">搜索引擎排名</span>
          </div>
        </template>
        <template v-slot="scope">
          <div class="rank-box">
            <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct4 }}</span>
            <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct4 }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct5!=''">
        <template slot="header" slot-scope="scope">
          <div>竞品5</div>
          <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct5" style="height: 40px; width: 40px"
                    fit="fill">
          </el-image>
          <div>{{ competitionProductDataDTO.asinOfCompetitionProduct5 }}</div>
          <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct5 }}</div>
          <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct5 }}</div>
          <div class="sub-heder">
            <span class="ads-rank">广告排名</span>
            <span class="search-key-rank">搜索引擎排名</span>
          </div>
        </template>
        <template v-slot="scope">
          <div class="rank-box">
            <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct5 }}</span>
            <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct5 }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="历史数据" :visible.sync="historyVisible" width="1300px">
      <el-table :data="historyKeywordDataDTOList" border style="width: 100%" cell-class-name="table-cell-no-padding"
                row-class-name="table-row-no-padding" header-cell-class-name="table-header-cell-no-padding">
        <el-table-column label="版本号" width="90px" align="center">
          <template slot-scope="scope">
            {{ scope.row.version }}
          </template>
        </el-table-column>
        <el-table-column prop="keyword" label="keyword" width="100px">
          <template v-slot="scope">
            <div style="margin-left: 6px;">{{ scope.row.keyword }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="rankOfKeyword" label="keyword排名" width="60px" align="center" sortable>
        </el-table-column>
        <el-table-column width="160px" align="center">
          <template slot="header" slot-scope="scope">
            <div>本品</div>
            <el-image :src="competitionProductDataDTO.imgUrl" style="height: 40px; width: 40px" fit="fill">
            </el-image>
            <div>{{ competitionProductDataDTO.asin }}</div>
            <div>商店名称:{{ competitionProductDataDTO.shopName }}</div>
            <div>单价:{{ competitionProductDataDTO.price }}</div>
            <div class="sub-heder">
              <span class="ads-rank">广告排名</span>
              <span class="search-key-rank">搜索引擎排名</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="rank-box">
              <div class="ads-rank">{{ scope.row.advertiseRankOfMolova }}</div>
              <div class="search-key-rank">{{ scope.row.rankOfMolova }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct1!=''">
          <template slot="header" slot-scope="scope">
            <div>竞品1</div>
            <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct1" style="height: 40px; width: 40px"
                      fit="fill">
            </el-image>
            <div>{{ competitionProductDataDTO.asinOfCompetitionProduct1 }}</div>
            <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct1 }}</div>
            <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct1 }}</div>
            <div class="sub-heder">
              <span class="ads-rank">广告排名</span>
              <span class="search-key-rank">搜索引擎排名</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="rank-box">
              <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct1 }}</span>
              <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct1 }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct2!=''">
          <template slot="header" slot-scope="scope">
            <div>竞品2</div>
            <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct2" style="height: 40px; width: 40px"
                      fit="fill">
            </el-image>
            <div>{{ competitionProductDataDTO.asinOfCompetitionProduct2 }}</div>
            <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct2 }}</div>
            <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct2 }}</div>
            <div class="sub-heder">
              <span class="ads-rank">广告排名</span>
              <span class="search-key-rank">搜索引擎排名</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="rank-box">
              <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct2 }}</span>
              <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct2 }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct3!=''">
          <template slot="header" slot-scope="scope">
            <div>竞品3</div>
            <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct3" style="height: 40px; width: 40px"
                      fit="fill">
            </el-image>
            <div>{{ competitionProductDataDTO.asinOfCompetitionProduct3 }}</div>
            <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct3 }}</div>
            <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct3 }}</div>
            <div class="sub-heder">
              <span class="ads-rank">广告排名</span>
              <span class="search-key-rank">搜索引擎排名</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="rank-box">
              <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct3 }}</span>
              <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct3 }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct4!=''">
          <template slot="header" slot-scope="scope">
            <div>竞品4</div>
            <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct4" style="height: 40px; width: 40px"
                      fit="fill">
            </el-image>
            <div>{{ competitionProductDataDTO.asinOfCompetitionProduct4 }}</div>
            <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct4 }}</div>
            <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct4 }}</div>
            <div class="sub-heder">
              <span class="ads-rank">广告排名</span>
              <span class="search-key-rank">搜索引擎排名</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="rank-box">
              <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct4 }}</span>
              <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct4 }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="160px" align="center" v-if="competitionProductDataDTO.asinOfCompetitionProduct5!=''">
          <template slot="header" slot-scope="scope">
            <div>竞品5</div>
            <el-image :src="competitionProductDataDTO.imgUrlOfCompetitionProduct5" style="height: 40px; width: 40px"
                      fit="fill">
            </el-image>
            <div>{{ competitionProductDataDTO.asinOfCompetitionProduct5 }}</div>
            <div>商店名称:{{ competitionProductDataDTO.shopNameOfCompetitionProduct5 }}</div>
            <div>单价:{{ competitionProductDataDTO.priceOfCompetitionProduct5 }}</div>
            <div class="sub-heder">
              <span class="ads-rank">广告排名</span>
              <span class="search-key-rank">搜索引擎排名</span>
            </div>
          </template>
          <template v-slot="scope">
            <div class="rank-box">
              <span class="ads-rank">{{ scope.row.advertiseRankOfCompetitionProduct5 }}</span>
              <span class="search-key-rank">{{ scope.row.rankOfCompetitionProduct5 }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  amazonModules
} from "@r";


export default {
  props: {
    queryParams: {
      type: Object,
      default() {
        return {};
      }
    },
    version: {
      type: Object,
      default() {
        return {};
      }
    },
    // productSearchKeywordDataDTOList: {
    //   type: Array,
    //   default() {
    //     return [];
    //   }
    // },
    // competitionProductDataDTO: {
    //   type: Object,
    //   default() {
    //     return {};
    //   }
    // }
  },
  data() {
    return {
      historyVisible: false,
      historyKeywordDataDTOList: [],
      rowData: {},
      competitionProductDataDTO: {},
      productSearchKeywordDataDTOList: []
    };
  },
  mounted() {
    this.getCompetitionByAsin();
  },
  methods: {
    openHistoryDialog(row) {
      this.getItem(row);
      this.historyVisible = true;
    },
    getItem(params) {
      params.asin = this.queryParams.asin;
      amazonModules.getSearchKeywordHistoryListUrl(params).then((data) => {
        if (data.result == 1) {
          this.historyKeywordDataDTOList = data.ldata;
          console.log(this.historyKeywordDataDTOList);
        }
      }).catch(err => {
        this.$message({
          type: "error",
          message: err.message ? err.message : "数据获取失败"
        });
      });
    },
    getCompetitionByAsin() {
      amazonModules.getCompetitionByAsin({"commodity": this.queryParams.asin, "version": this.version}).then((data) => {
        if (data.result == 1) {
          this.competitionProductDataDTO = data.mdata.competitionProductDataDTO;
          this.productSearchKeywordDataDTOList = data.mdata.productSearchKeywordDataDTOList;
          console.log(this.historyKeywordDataDTOList);
        }
      }).catch(err => {
        this.$message({
          type: "error",
          message: err.message ? err.message : "数据获取失败"
        });
      });
    }
  },
}
</script>

<style lang="scss">
.keywords-rank {
  .table-cell-no-padding {
    padding: 0px !important;

    .cell {
      padding-left: 0px !important;
      padding-right: 0px !important;
      line-height: 16px;
    }
  }

  .table-header-cell-no-padding {
    padding: 0px !important;

    .cell {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }

  .sub-heder {
    border-top: solid 1px gainsboro;
  }

  .sub-heder, .rank-box {
    .ads-rank {
      display: inline-block;
      width: 58px;
      border-right: 1px solid #EBEEF5;
      height: 28px;
      line-height: 28px;
    }

    .search-key-rank {
      display: inline-block;
      width: 85px;
      float: right;
      height: 28px;
      line-height: 28px;
    }
  }

  .el-button {
    white-space: pre-line;
    text-align: left;
    border: 0px;
    padding: 0px;
    line-height: normal;
  }

}
</style>
